export default {"src":"/_next/static/media/CRSP.6af491d4.svg","height":18,"width":18};